import React, { useRef, useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import { Link, useHistory } from "react-router-dom";

export default function Signup() {
  const emailRef = useRef();
  const passwordRef = useRef();
  const passwordConfirmRef = useRef();
  const { signup, currentUser } = useAuth();
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  async function handleSubmit(e) {
    e.preventDefault();

    if (passwordRef.current.value !== passwordConfirmRef.current.value) {
      return setError("Passwords do not match");
    }

    try {
      setError("");
      setLoading(true);
      await signup(emailRef.current.value, passwordRef.current.value);
      history.push("/dashboard");
    } catch {
      setError("Failed to create an account");
      setLoading(false);
    }
  }

  return (
    <>
      {!currentUser ? (
        <div className="section-container">
          <section className="form-section">
            <div className="form-field">
              <h1 className="form-header">Sign Up</h1>
              {error && <div className="error-box">{error}</div>}
              <form onSubmit={handleSubmit}>
                <div id="email" className="flex-column form-var">
                  <label>Email</label>
                  <input
                    className="form-input"
                    type="email"
                    ref={emailRef}
                    autoComplete="username"
                    required
                  />
                </div>
                <div id="password" className="flex-column form-var">
                  <label>Password</label>
                  <input
                    className="form-input"
                    type="password"
                    autoComplete="new-password"
                    ref={passwordRef}
                    required
                  />
                </div>
                <div id="password-confirm" className="flex-column form-var">
                  <label>Password Confirmation</label>
                  <input
                    className="form-input"
                    type="password"
                    autoComplete="new-password"
                    ref={passwordConfirmRef}
                    required
                  />
                </div>
                <button disabled={loading} className="btn form-btn" type="submit">
                  Sign Up
                </button>
                <div className="form-input-add">
                  By signing up you agree to our{" "}
                  <Link className="link-text" to="/privacy">
                    Privacy Policy
                  </Link>
                </div>
                <div className="form-reference">
                  Already have an account?{" "}
                  <Link className="link-text" to="/login">
                    Log In
                  </Link>
                </div>
              </form>
            </div>
          </section>
          <section id="demo-cta-section">
            <Link className="link-text cta" to="/dashboard-demo">
              Show me a demo first
            </Link>
          </section>
        </div>
      ) : (
        <div className="section-container">
          <section>
            <h1 className="section-header">Already logged in</h1>
          </section>
        </div>
      )}
    </>
  );
}
